
















































import { Component, Prop, VModel, Vue } from "vue-property-decorator"

@Component
export default class QuestionDependencyImpactedTarget extends Vue {
  @VModel() impactedTargetBridge!: boolean
  @Prop() readonly options!: []

  customFilter(item, queryText) {
    return (
      item.body.includes(queryText) ||
      (item.internal_annotation && item.internal_annotation.includes(queryText))
    )
  }

  getQuestionItemText(item) {
    return this.$options.filters?.escapeHtml(item.body + " - " + item.object_id)
  }

  isInternalAnnotationExisted(question) {
    if (!question) {
      return false
    }

    if (!question.internal_annotation) {
      return false
    }

    if (!question.internal_annotation.length) {
      return false
    }

    return true
  }
}
